import { useState } from 'react';
import { SUPPORT_EMAIL } from '../utils/constants';

// Keep this list in sync with getFAQSchema() in utils/seo.js.
const faqs = [
  {
    q: 'What do I need to run it?',
    a: 'A Claude subscription (the agents run on your plan) and a transcription provider API key for meeting capture. You install the app on Windows or macOS and plug in your own keys — that\'s it.',
  },
  {
    q: 'Are there any ongoing costs to Solidly?',
    a: 'The app is a one-time purchase — buy it once and own it forever, including all future updates. The only subscription we offer is the optional Solidly Sync add-on ($5/month) for encrypted backup and multi-device sync, and the app is fully functional without it. Everything else you pay goes straight to your own providers (Claude and your transcription key) for what you actually use.',
  },
  {
    q: 'Is my meeting data private?',
    a: 'Meetings are captured on your machine — no bot joins the call. Transcription runs on your own provider key and agents run on your own Claude subscription. By default your workspace stays on your device; if you enable the optional Solidly Sync add-on, your data is encrypted before it ever leaves your machine.',
  },
  {
    q: 'What is Solidly Sync?',
    a: 'An optional $5/month add-on for encrypted cloud backup and multi-device sync. Back up your whole workspace — agents, schedules, history — and restore it on another machine in minutes. You pick one primary device to run your scheduled agents, so the same job never fires twice. Cancel anytime; the app keeps working fully on your device.',
  },
  {
    q: 'What powers the agents?',
    a: 'The agents are built on Claude and run on your own Claude subscription. You manage a team of scheduled and on-demand agents that coordinate and hand work off to each other, with output streamed live.',
  },
  {
    q: 'Which Claude plan do I need?',
    a: 'Any paid Claude plan works — agents run through Claude on your own account, so your plan\'s usage limits are the ceiling. A handful of scheduled agents fits comfortably on Pro; if you run heavy overnight schedules, a higher-tier plan gives you more headroom.',
  },
  {
    q: 'How many devices can I use it on?',
    a: `Your license activates on up to 3 devices — desktop and laptop both, no extra charge. Moving to a new machine? Email ${SUPPORT_EMAIL} and we'll free up a slot. The optional Solidly Sync add-on moves your whole workspace over in minutes.`,
  },
  {
    q: 'Which operating systems are supported?',
    a: 'SolidlyAI Agents is a desktop app for Windows and macOS.',
  },
  {
    q: 'What\'s your refund policy?',
    a: `A 7-day money-back guarantee. If it isn't for you, email ${SUPPORT_EMAIL} within 7 days of purchase for a full refund — no forms, no questions.`,
  },
  {
    q: 'Do I get updates?',
    a: 'Yes — every future update is included free, for the lifetime of the product. The app updates itself automatically, with no upgrade fees and no subscription required.',
  },
  {
    q: 'How do I get help?',
    a: `Email ${SUPPORT_EMAIL} — questions, bug reports, and refunds all go to the same address, and a human reads every message.`,
  },
];

const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="faq" id="faq">
      <div className="section-container">
        <p className="overline overline--center">FAQ</p>
        <h2 className="section-title">Questions, answered</h2>

        <ul className="faq-list">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <li key={i} className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{item.q}</span>
                  <span className="faq-toggle" aria-hidden="true">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>
                {isOpen && <p className="faq-answer">{item.a}</p>}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Faq;
